module.exports = __webpack_public_path__ + "static/media/card-home-mysterybox.8bd53597.png";